module.exports = __webpack_public_path__ + "img/labmem_text_btnfinish_kr.100ab8fc.png";